import { render, staticRenderFns } from "./GroupDetailsPopup.vue?vue&type=template&id=6a772a8a&scoped=true&"
import script from "./GroupDetailsPopup.vue?vue&type=script&lang=js&"
export * from "./GroupDetailsPopup.vue?vue&type=script&lang=js&"
import style0 from "./GroupDetailsPopup.vue?vue&type=style&index=0&id=6a772a8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a772a8a",
  null
  
)

export default component.exports